import React, { useContext, useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import * as L from 'leaflet';
import { GlobalContext } from '../../App';

const TCILayers = () => {
  const map = useMap();
  const { tciLayers, showTciLayers } = useContext(GlobalContext);
  const layersRef = useRef([]);

  useEffect(() => {
    console.log('🗺️ TCILayers useEffect triggered:', { showTciLayers, tciLayersCount: tciLayers.length, tciLayers });
    
    // Remove existing layers
    layersRef.current.forEach(layer => {
      if (map.hasLayer(layer)) {
        console.log('🗑️ Removing existing layer');
        map.removeLayer(layer);
      }
    });
    layersRef.current = [];

    // Add new layers if visible
    if (showTciLayers && tciLayers.length > 0) {
      console.log('✨ Adding TCI layers to map');
      tciLayers.forEach(tciLayer => {
        // Check if it's a tile URL (contains {z}/{x}/{y}) or image URL
        const isTileUrl = tciLayer.imageUrl.includes('{z}') || tciLayer.imageUrl.includes('%7Bz%7D');
        console.log('🌐 Processing TCI layer:', { isTileUrl, url: tciLayer.imageUrl, bounds: tciLayer.bounds });
        
        let leafletLayer;
        if (isTileUrl) {
          console.log('🏞️ Creating TileLayer');
          // Use TileLayer for Google Earth Engine tiles
          leafletLayer = L.tileLayer(tciLayer.imageUrl, {
            opacity: 0.8,
            attribution: `TCI ${tciLayer.date}`,
            maxZoom: 18,
            zIndex: 500 + tciLayers.indexOf(tciLayer)
          });
        } else {
          console.log('🖼️ Creating ImageOverlay');
          // Use ImageOverlay for static images
          leafletLayer = L.imageOverlay(
            tciLayer.imageUrl,
            tciLayer.bounds,
            {
              opacity: 0.8,
              attribution: `TCI ${tciLayer.date}`,
              zIndex: 500 + tciLayers.indexOf(tciLayer)
            }
          );
        }
        
        console.log('➕ Adding layer to map');
        leafletLayer.addTo(map);
        
        // TCI layers should stay in middle layer (below polygons)
        
        layersRef.current.push(leafletLayer);
        
        // Add error handling
        leafletLayer.on('tileerror', (e) => {
          console.error('❌ TCI Tile error:', e);
        });
        
        leafletLayer.on('tileload', (e) => {
          console.log('✅ TCI Tile loaded:', e.coords);
        });

        // Add date label
        const center = [
          (tciLayer.bounds[0][0] + tciLayer.bounds[1][0]) / 2,
          (tciLayer.bounds[0][1] + tciLayer.bounds[1][1]) / 2
        ];
        
        const label = L.marker(center, {
          icon: L.divIcon({
            className: 'tci-date-label',
            html: `<div style="background: rgba(0,0,0,0.7); color: white; padding: 4px 8px; border-radius: 4px; font-size: 12px; white-space: nowrap;">${tciLayer.date}</div>`,
            iconSize: [0, 0],
            iconAnchor: [0, 0]
          })
        });
        
        label.addTo(map);
        layersRef.current.push(label);
      });
    }

    return () => {
      layersRef.current.forEach(layer => {
        if (map.hasLayer(layer)) {
          map.removeLayer(layer);
        }
      });
    };
  }, [map, tciLayers, showTciLayers]);

  return null;
};

export default TCILayers;